import posthog from 'posthog-js';
import { isPostHogEnabled } from './posthog';

/**
 * Failed API requests, counted per endpoint and status. There is deliberately no parameter here that could carry
 * the request's url, its body, the error message or a record id.
 */

/** The HTTP status of the answer, or `network` when none arrived. */
export type ApiRequestFailureStatus = number | 'network';

export interface ApiRequestFailedEvent {
    /** The RTK Query endpoint name, a fixed identifier from the API definitions. */
    endpoint: string;
    kind: 'query' | 'mutation';
    status: ApiRequestFailureStatus;
}

export function captureApiRequestFailed({ endpoint, kind, status }: ApiRequestFailedEvent): void {
    if (!isPostHogEnabled) {
        return;
    }
    posthog.capture('api_request_failed', { endpoint, kind, status });
}

/**
 * The status of an RTK Query error. A body that is not JSON, such as a gateway's 502 page, arrives as `PARSING_ERROR`
 * with the HTTP status in `originalStatus`; a request that got no answer arrives as `FETCH_ERROR`, with neither.
 */
export function failureStatusOf(error: Record<string, unknown> | undefined): ApiRequestFailureStatus {
    if (typeof error?.status === 'number') {
        return error.status;
    }
    return typeof error?.originalStatus === 'number' ? error.originalStatus : 'network';
}
